
const parseJSON = (val) => {
  try {
    return JSON.parse(val);
  }
  catch (e) {
    console.error(e)
    return undefined;
  }
};

export default parseJSON;